import { inject, ref } from 'vue';
import { invalidateOrgReferenceOptions } from '@/api/orgReferenceApi';

/**
 * Settings entity list helper (departments, positions, etc.).
 * Unlike org-reference lists, each section owns its fetch API.
 */
export function useSettingsEntityList({ invalidateProfileOptions = true } = {}) {
  const showInactive = ref(false);
  const refreshWorkspaceStats = inject('refreshWorkspaceStats', null);

  const afterMutation = async (reloadFn) => {
    if (invalidateProfileOptions) {
      invalidateOrgReferenceOptions();
    }
    if (typeof reloadFn === 'function') {
      await reloadFn();
    }
    refreshWorkspaceStats?.();
  };

  return {
    showInactive,
    afterMutation,
  };
}
